import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import e from "../core/Collection.js";
import { referenceSetter as r } from "../core/collectionUtils.js";
import s from "../core/Logger.js";
import { property as o } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as i } from "../core/accessorSupport/decorators/subclass.js";
var a = "esri.support.TablesMixin",
    n = s.getLogger(a);

function l(t) {
  return t && "group" === t.type;
}

function p(t, e, r) {
  if (t) for (var _s = 0, _o = t.length; _s < _o; _s++) {
    var _o2 = t.getItemAt(_s);

    if (_o2[e] === r) return _o2;

    if (l(_o2)) {
      var _t = p(_o2.tables, e, r);

      if (_t) return _t;
    }
  }
}

var c = function c(s) {
  var l = /*#__PURE__*/function (_s2) {
    _inherits(l, _s2);

    var _super = _createSuper(l);

    function l() {
      var _this;

      _classCallCheck(this, l);

      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(t)), _this.tables = new e(), _this.tables.on("after-add", function (t) {
        var e = t.item;
        e.parent && e.parent !== _assertThisInitialized(_this) && "tables" in e.parent && e.parent.tables.remove(e), e.parent = _assertThisInitialized(_this), "feature" !== e.type && n.error("Layer 'title:".concat(e.title, ", id:").concat(e.id, "' of type '").concat(e.type, "' is not supported as a table and will therefore be ignored."));
      }), _this.tables.on("after-remove", function (t) {
        t.item.parent = null;
      });
      return _this;
    }

    _createClass(l, [{
      key: "destroy",
      value: function destroy() {
        var t = this.tables.removeAll();

        var _iterator = _createForOfIteratorHelper(t),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;

            _e.destroy();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        this.tables.destroy();
      }
    }, {
      key: "tables",
      set: function set(t) {
        this._set("tables", r(t, this._get("tables")));
      }
    }, {
      key: "findTableById",
      value: function findTableById(t) {
        return p(this.tables, "id", t);
      }
    }, {
      key: "findTableByUid",
      value: function findTableByUid(t) {
        return p(this.tables, "uid", t);
      }
    }]);

    return l;
  }(s);

  return t([o()], l.prototype, "tables", null), l = t([i(a)], l), l;
};

export { c as TablesMixin };